import type { OptionGroup } from './SearchableOptionList'
import type { SearchableOption } from './SearchableSelect'

function optionMatches<TValue>(o: SearchableOption<TValue>, q: string): boolean {
  if (!q) return true
  return (
    o.label.toLowerCase().includes(q) ||
    (o.hint?.toLowerCase().includes(q) ?? false) ||
    (o.searchTokens?.toLowerCase().includes(q) ?? false) ||
    String(o.value).toLowerCase().includes(q)
  )
}

/** The rows that match the search, with the main list clustered by `group`.
 *  FO-24: a row already shown under "Most used" is left out of the main list,
 *  so a pinned country (Nepal) is never listed twice. */
export function filterAndGroup<TValue>(
  options: SearchableOption<TValue>[],
  topOptions: SearchableOption<TValue>[] | undefined,
  query: string,
) {
  const q = query.trim().toLowerCase()
  const filteredTop = topOptions?.filter((o) => optionMatches(o, q)) ?? []
  const pinned = new Set(filteredTop.map((o) => o.value))
  const filteredAll = options.filter((o) => !pinned.has(o.value) && optionMatches(o, q))
  const groups: OptionGroup<TValue>[] = []
  if (filteredAll.some((o) => o.group)) {
    const map = new Map<string, SearchableOption<TValue>[]>()
    for (const o of filteredAll) {
      const g = o.group ?? '-'
      const bucket = map.get(g)
      if (bucket) bucket.push(o)
      else map.set(g, [o])
    }
    for (const [label, items] of map) groups.push({ label, items })
  } else {
    groups.push({ label: null, items: filteredAll })
  }
  return { filteredTop, filteredAll, groups }
}
